var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListViewShowing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 8C6.75 6.48122 5.51878 5.25 4 5.25C2.48122 5.25 1.25 6.48122 1.25 8C1.25 9.51878 2.48122 10.75 4 10.75C5.51878 10.75 6.75 9.51878 6.75 8ZM6.75 16C6.75 14.4812 5.51878 13.25 4 13.25C2.48122 13.25 1.25 14.4812 1.25 16C1.25 17.5188 2.48122 18.75 4 18.75C5.51878 18.75 6.75 17.5188 6.75 16ZM9.25 6C9.25 5.58579 9.58579 5.25 10 5.25H16C16.4142 5.25 16.75 5.58579 16.75 6C16.75 6.41421 16.4142 6.75 16 6.75H10C9.58579 6.75 9.25 6.41421 9.25 6ZM10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75H16C16.4142 14.75 16.75 14.4142 16.75 14C16.75 13.5858 16.4142 13.25 16 13.25H10ZM9.25 10C9.25 9.58579 9.58579 9.25 10 9.25H22C22.4142 9.25 22.75 9.58579 22.75 10C22.75 10.4142 22.4142 10.75 22 10.75H10C9.58579 10.75 9.25 10.4142 9.25 10ZM10 17.25C9.58579 17.25 9.25 17.5858 9.25 18C9.25 18.4142 9.58579 18.75 10 18.75H22C22.4142 18.75 22.75 18.4142 22.75 18C22.75 17.5858 22.4142 17.25 22 17.25H10Z",
    fill: "#38499b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewShowing);
export default __webpack_public_path__ + "static/media/list-view-showing.b51fac8dd25dd20ac9e13ac4ead66b31.svg";
export { ForwardRef as ReactComponent };